// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/app.scss
// module id = nYAk
// module chunks = 1